import { useCallback, useMemo } from 'react'

import {
  OrderQuoteParams,
  SetOrderQuoteParams,
  SetOrderQuoteParamsForInstrument,
} from '../constants/order'
import { getDefaultOrderQuoteParams } from '../utils/order'

export default function useOrderParamsStateForInstrument(
  instrumentName: string,
  orderParamsNullable: OrderQuoteParams | null,
  setOrderParamsNullable: SetOrderQuoteParams
): [OrderQuoteParams, SetOrderQuoteParamsForInstrument] {
  const orderParams = useMemo(
    () => orderParamsNullable ?? getDefaultOrderQuoteParams(instrumentName),
    [orderParamsNullable, instrumentName]
  )

  const setOrderParams: SetOrderQuoteParamsForInstrument = useCallback(
    (valueOrFunc) =>
      setOrderParamsNullable(
        typeof valueOrFunc === 'function' ? valueOrFunc(orderParams) : valueOrFunc
      ),
    [orderParams, setOrderParamsNullable]
  )

  return useMemo(() => {
    return [orderParams, setOrderParams]
  }, [orderParams, setOrderParams])
}
